import { render, staticRenderFns } from "./ModalExportarCatalogo.vue?vue&type=template&id=378e1b84&"
import script from "./ModalExportarCatalogo.vue?vue&type=script&lang=js&"
export * from "./ModalExportarCatalogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports